import { useEffect, useState } from "react";
import _ from "lodash";
import { Select } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { fetchContacts } from "services/customers.service";

const CustomerContactSelect = ({
  value,
  onChange,
  isRequired = false,
  name = "",
  isDisable = false,
  label = "select_contact",
  customerId = "",
  error: propsErr = "",
  onSelectedOptionChange = (_value, _label) => {},
}) => {
  const { t } = useTranslation();
  const [collection, setCollection] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { companyId } = useParams();
  const [error, setError] = useState("");

  const handleChange = (selectedValue) => {
    if (isRequired && !selectedValue) {
      setError(t("field_is_required"));
    } else {
      setError("");
    }

    onChange(selectedValue, name);
    const option = collection.find((item) => item.value === selectedValue);
    onSelectedOptionChange(selectedValue, option?.label || "");
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setIsLoading(true);
        const data = await fetchContacts(companyId, customerId);
        const dataCollection = _.map(data.contactsCollection, (row) => ({
          label: row.name || row.email,
          value: row.id != null ? String(row.id) : "",
        }));

        if (!isRequired) {
          dataCollection.unshift({ label: " - ", value: "" });
        } else if (dataCollection.length === 1) {
          onChange(dataCollection[0].value);
        } else if (dataCollection.length > 1) {
          dataCollection.unshift({ label: " - ", value: "" });
        }
        setCollection(dataCollection);
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    }
    fetchData();
  }, [companyId, customerId]);

  useEffect(() => {
    if (collection.length && !collection.some((item) => item.value === value)) {
      onChange(collection[0].value);
    }
    // Don't clear when parent has pre-filled a value (e.g. from existing signers)
    if (!collection.length && !isLoading && !value) {
      onChange("");
    }
  }, [value, collection]);

  return (
    <div>
      <Select
        label={t(label)}
        options={collection}
        value={value}
        disabled={isLoading || isDisable}
        onChange={handleChange}
        error={error || propsErr}
        requiredIndicator={isRequired ? true : false}
      />
    </div>
  );
};

export default CustomerContactSelect;
